import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  List,
  ListItem,
  ListItemText,
  Avatar,
  Typography,
  TextField,
  Button,
  Grid,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  MenuItem,
  Select,
  Grid2,
  Container,
} from "@mui/material";
import OrderSummary from "../../components/OrderSummary/OrderSummary";
import { Delete } from "@mui/icons-material";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import "./MyCart.css";
import * as animationData from "../../components/Lottie/noResults.json";
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getCustomerCart } from "../../utilities/cartUtils";
import { useDispatch } from "react-redux";
import { deleteCart, fetchCartByCustomerId, removeCartItem, updateCartItem } from "../../redux/cartSlice";
import { Loader } from "../../components/loader/loader";

const HEIGHT = window.innerHeight;
const WIDTH = window.innerWidth;

// Define types for cart items and products
interface Product {
  productId: number;
  productName: string;
  salePrice: number;
  productDiscount?: number;
  imgSrc?: string;
}

interface CartItem {
  cartItemId: number;
  product: Product;
  quantity: number;
  totalPrice: number;
  unitPrice: number;
}

interface CartItemsProps {
  cartData: CartItem[];
  handleQuantityChange: any;
  removeItem: any;
  handleNavigation: any;
  removeCart: any
}

const CartItems: React.FC<CartItemsProps> = ({ cartData, handleQuantityChange, removeItem, handleNavigation, removeCart }) => (
  < Box sx={{
    textAlign: 'center'
  }}>

    {cartData && cartData.length > 0 ?
      <>
        {cartData.map((cart: any, index: any) => (
          <Paper
            elevation={3}
            sx={{
              borderRadius: 2,
              // padding: 2.5,
              marginTop: 2.5,
              // minHeight: WIDTH < 400 ? "auto" : "30vh",
              // maxHeight: WIDTH < 400 ? "auto" : "60vh",
              overflowY: WIDTH < 400 ? "visible" : "auto", // Adds scrolling if content overflows on larger screens
            }}
          >
            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{
                  backgroundColor: "#e0d9d9"
                }}
              >
                {/* <Grid2 container spacing={4}> */}

                <Grid2 size={{ xs: 4, sm: 4, md: 4, lg: 4 }} sx={{
                  textAlignLast: "left", marginLeft: "10px", marginTop: "10px"
                }}>
                  <Typography component="span" sx={{ fontSize: '17px' }}>
                    <strong>{cart.cartName} {" "} ({cart.cartItems ? cart.cartItems.length : 0} items)</strong>
                  </Typography>

                </Grid2>

                <Grid2 size={{ xs: 8, sm: 8, md: 8, lg: 8 }} sx={{
                  textAlignLast: "right", marginRight: "10px", marginTop: "10px"
                }}>
                  {/* <Button
                    variant="contained"
                    color="primary"
                    sx={{ mb: 2, mr: 3, backgroundColor: "#DC2626", padding: '4px 10px', fontSize: '14px' }}
                    onClick={(e) => removeCart(cart.cartId)}
                  >
                    <span>{"DELETE CART"}</span>
                  </Button> */}

                  <Typography component="span" sx={{ fontSize: '18px', verticalAlign: 'text-bottom', mr: 4, mb: 4 }}>
                    <strong>$ {cart.cartItems ? parseFloat((cart.cartItems.reduce((sum: any, item: any) => sum + item.totalPrice, 0))).toFixed(2) : 0.00}</strong>
                  </Typography>

                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ mb: 2, backgroundColor: "green", padding: '4px 10px', fontSize: '14px' }}
                    onClick={(e) => handleNavigation(cart.cartId)}
                    disabled={!cart.cartItems || cart.cartItems.length == 0}
                  >
                    <span>{"CHECKOUT"}</span>
                  </Button>

                </Grid2>
                {/* </Grid2> */}

              </AccordionSummary>
              <AccordionDetails>
                <List>
                  {cart.cartItems && cart.cartItems.map((item: CartItem, index: any) => (
                    <React.Fragment key={item.cartItemId}>
                      <ListItem sx={{ display: "flex", alignItems: "center" }}>
                        <ListItemText>
                          <Grid2 container spacing={2}>
                            <Grid2 size={{ xs: 2, sm: 2, md: 2, lg: 2 }}>
                              <Avatar
                                src={require("../../../assets/Home/Cctv.png")}
                                sx={{ width: 60, height: 60, mr: 2 }}
                              />
                            </Grid2>
                            <Grid2 size={{ xs: 10, sm: 6, md: 6, lg: 7 }}>
                              <ListItemText
                                primary={<Typography component="span">
                                  <strong>{item.product.productName}</strong>
                                </Typography>}
                                secondary={
                                  <Box style={{ display: "grid" }}>
                                    <Typography component="span">
                                      <Typography component="span" color="error">
                                        ${item.unitPrice ? item.unitPrice : "0.00"}
                                      </Typography>
                                    </Typography>
                                    {/* <img
                            src={require("../../../assets/shippings.png")}
                            alt="shipping"
                          /> */}
                                  </Box>
                                }
                              />
                            </Grid2>
                            <Grid2 size={{ xs: 4, sm: 2, md: 2, lg: 1 }} mt={1}>
                              <Typography component="span" color="error">
                                <strong>${item.totalPrice}</strong>
                              </Typography>
                            </Grid2>
                            <Grid2 size={{ xs: 4, sm: 1, md: 1, lg: 1 }}>
                              {/* <TextField
                              defaultValue={item.quantity}
                              onInput={(e: any) => handleQuantityChange(cart.cartId, item, e.target.value)}
                              sx={{
                                width: 80,
                                mr: 2,
                                "& .MuiOutlinedInput-root": {
                                  width:
                                    WIDTH < 400 ? (WIDTH * 25) / 100 : (WIDTH * 7) / 100,
                                  "& .MuiInputBase-input": {
                                    height: "5px",
                                  },
                                },
                              }}
                            /> */}
                              <Select

                                defaultValue={item.quantity}
                                onChange={(e: any) => handleQuantityChange(cart.cartId, item, e.target.value)}
                                size="small"
                              >
                                {[1, 2, 3, 4, 5, 6, 7, 8].map((number) => (
                                  <MenuItem value={number}>{number}</MenuItem>
                                ))}
                              </Select>
                            </Grid2>

                            <Grid2 size={{ xs: 4, sm: 1, md: 1, lg: 1 }}>
                              <Button color="error" onClick={() => removeItem(cart.cartName, index, item.cartItemId)}>
                                <Delete />
                              </Button>
                            </Grid2>
                          </Grid2>
                        </ListItemText>
                      </ListItem>

                    </React.Fragment>
                  ))} </List>
              </AccordionDetails>
            </Accordion>
          </Paper>
        ))}

      </>
      : <>
        <Box component="img"
          style={{ marginRight: WIDTH * 0.7 / 100, width: '15%', textAlign: 'center', minHeight: '300px' }}
          src={require('../../../assets/Home/emptycart.jpg')} />
        <Typography style={{ textAlign: 'center', verticalAlign: 'middle', marginBottom: '10px' }}><strong>No Cart Items found</strong></Typography>
      </>
    }

    {/* <Paper
      elevation={3}
      sx={{ padding: 2.5, borderRadius: 2 }}
      style={{ marginTop: 30, textAlign: 'left' }}
    >
      <Box mt={2} display="flex" alignItems="center">
        <img src={require("../../../assets/shipp.png")} />
      </Box>
      <Typography
        sx={{
          ml: 1,
          fontSize: "12px",
          color: "#848484",
          marginTop: (HEIGHT * 0.2) / 100,
          marginLeft: (WIDTH * 0.3) / 100,
        }}
      >
        Well we human race are enchanted by fine artefact, so what’s better than
        Fashion? This would be one of the best ways to attract attention towards
        the adverse effects of manoeuvring nature’ by developing a whole new set
        of. Well we human race are enchanted by fine artefact, so what’s better
        than Fashion?
      </Typography>
    </Paper> */}

    {/* <Grid container spacing={2} mt={2}>
      <Grid item xs={12} lg={3} sx={{ textAlign: "center" }} className="fgt">
        <img src={require("../../../assets/secu.png")} alt="Secure Payment" />
        <Box style={{ textAlign: "left", marginLeft: "10px" }}>
          <Typography>Secure Payment</Typography> */}
    {/* <Typography style={{color: "#A9ACB0"}}>Have you ever finally just </Typography> */}
    {/* </Box>
      </Grid>
      <Grid item xs={12} lg={3} sx={{ textAlign: "center" }} className="fgt">
        <img src={require("../../../assets/suppo.png")} alt="24/7 Support" />
        <Box style={{ textAlign: "left", marginLeft: "10px" }}>
          <Typography>24/7 Support</Typography> */}
    {/* <Typography style={{color: "#A9ACB0"}}>Have you ever finally just </Typography> */}
    {/* </Box>
      </Grid>
      <Grid item xs={12} lg={3} sx={{ textAlign: "center" }} className="fgt">
        <img src={require("../../../assets/freesh.png")} alt="Free Shipping" />
        <Box style={{ textAlign: "left", marginLeft: "10px" }}>
          <Typography>Free Shipping</Typography> */}
    {/* <Typography style={{color: "#A9ACB0"}}>Have you ever finally just </Typography> */}
    {/* </Box>
      </Grid>
      <Grid item xs={12} lg={3} sx={{ textAlign: "center" }} className="fgt">
        <Box
          style={{
            borderRadius: "100px",
            backgroundColor: "#DEE2E7",
            padding: 8,
            height: 32,
            width: 32,
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <img
            src={require("../../../assets/rep.png")}
            alt="2 Days Refundable"
          />
        </Box>
        <Box style={{ textAlign: "left", marginLeft: "10px" }}>
          <Typography>2 Days Refundable</Typography> */}
    {/* <Typography style={{color: "#A9ACB0"}}>Have you ever finally just </Typography> */}
    {/* </Box>
      </Grid>
       </Grid> */}
  </Box >
);

const MyCart = () => {
  const [cartData, setCartData] = useState([]);
  const [customerId, setCustomerId] = useState<any>();
  const [token, setToken] = useState<any>();
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setIsLoading(false);
  }

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("token");
    if (!isLoggedIn) {
      navigate("/login");
    }
    setCustomerId(localStorage.getItem("customerId"));
    setToken(localStorage.getItem("token"));
    getCustCartData();
  }, []);

  const getCustCartData = () => {
    if (!isLoading) { setIsLoading(true); }
    getCustomerCart(dispatch).then(() => {
      setIsLoading(false);
      const customerCarts = localStorage.getItem("customercarts");
      if (customerCarts) {
        const parsedCarts: any = JSON.parse(customerCarts);
        setCartData(parsedCarts);
      }
    }).catch(err => {
      setIsLoading(false);
      console.log(err);
    });
  }

  const handleQuantityChange = async (cartId: any, cartItem: any, quantity: any) => {
    if (cartId) {
      if (!isLoading) { setIsLoading(true); }
      let newQuantity = parseInt(quantity);
      let updatedCartItem = {
        ...cartItem,
        "quantity": newQuantity,
        "totalPrice": cartItem.unitPrice * newQuantity
      }
      let item: any = { cartId: cartId, ...updatedCartItem };
      const response = await dispatch(updateCartItem(item)).unwrap();
      getCustCartData();
    }
  }

  const removeItem = async (cartName: any, index: number, cartItemId: any) => {
    if (cartData) {
      if (!isLoading) { setIsLoading(true); }
      let selectedCart: any = cartData.find((x: any) => x.cartName == cartName);
      let customerId = localStorage.getItem("customerId");
      let req = {
        cartName: cartName,
        cartItemId: cartItemId,
        customerId: customerId
      }
      const response = await dispatch(removeCartItem(req)).unwrap();
      getCustCartData();
    }
  };

  const removeCart = async (cartId: any) => {
    if (cartId) {
      if (!isLoading) { setIsLoading(true); }
      const response = await dispatch(deleteCart(cartId)).unwrap();
      getCustCartData();
    }
  };


  const confirmOrder = (cartId: number) => {
    navigate("/confirm-order", { state: { cartId } });
  };


  return (
    <>
      <Header />
      <Container disableGutters={false} maxWidth={false} sx={{ maxWidth: '1400px', marginTop: '105px', minWidth: '1000px' }}>
        <Loader loading={isLoading} handleClose={handleClose} />
        <Box>
          <Typography variant="h6"><strong>My Carts ({cartData ? cartData.length : 0})</strong></Typography>
          <Grid2 container spacing={2}>
            {/* <Grid item xs={12} md={cartItems && cartItems.length > 0 ? 8 : 12}> */}
            <Grid2 size={{ xs: 12, md: 12 }}>
              <CartItems cartData={cartData} handleQuantityChange={handleQuantityChange} removeItem={removeItem}
                removeCart={removeCart} handleNavigation={confirmOrder} />
            </Grid2>
            <Paper
              elevation={3}
              sx={{ padding: 2.5, borderRadius: 2 }}
              style={{ marginTop: 30, textAlign: 'left' }}
            >
              <Box mt={2} display="flex" alignItems="center">
                <img src={require("../../../assets/shipp.png")} />
              </Box>
              <Typography
                sx={{
                  ml: 1,
                  fontSize: "12px",
                  color: "#848484",
                  marginTop: (HEIGHT * 0.2) / 100,
                  marginLeft: (WIDTH * 0.3) / 100,
                }}
              >
                Well we human race are enchanted by fine artefact, so what’s better than
                Fashion? This would be one of the best ways to attract attention towards
                the adverse effects of manoeuvring nature’ by developing a whole new set
                of. Well we human race are enchanted by fine artefact, so what’s better
                than Fashion?
              </Typography>
            </Paper>
            <Grid2 size={{ xs: 12, md: 12 }}>
              <Grid2 direction={'row'} container spacing={{ lg: 4 }} mt={2} mb={2}>
                <Grid2 size={{ xs: 2, sm: 6, md: 3, xl: 3 }} sx={{ textAlign: "center" }} className="fgt">
                  <img src={require("../../../assets/secu.png")} alt="Secure Payment" />
                  <Box style={{ textAlign: "left", marginLeft: "10px" }}>
                    <Typography>Secure Payment</Typography>
                    {/* <Typography style={{color: "#A9ACB0"}}>Have you ever finally just </Typography> */}
                  </Box>
                </Grid2>
                <Grid2 size={{ xs: 2, sm: 6, md: 3, xl: 3 }} sx={{ textAlign: "center" }} className="fgt">
                  <img src={require("../../../assets/suppo.png")} alt="24/7 Support" />
                  <Box style={{ textAlign: "left", marginLeft: "10px" }}>
                    <Typography>24/7 Support</Typography>
                    {/* <Typography style={{color: "#A9ACB0"}}>Have you ever finally just </Typography> */}
                  </Box>
                </Grid2>
                <Grid2 size={{ xs: 2, sm: 6, md: 3, xl: 3 }} sx={{ textAlign: "center" }} className="fgt">
                  <img src={require("../../../assets/freesh.png")} alt="Free Shipping" />
                  <Box style={{ textAlign: "left", marginLeft: "10px" }}>
                    <Typography>Free Shipping</Typography>
                    {/* <Typography style={{color: "#A9ACB0"}}>Have you ever finally just </Typography> */}
                  </Box>
                </Grid2>
                <Grid2 size={{ xs: 2, sm: 6, md: 3, xl: 3 }} sx={{ textAlign: "center" }} className="fgt">
                  <Box
                    style={{
                      borderRadius: "100px",
                      backgroundColor: "#DEE2E7",
                      padding: 8,
                      height: 32,
                      width: 32,
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                    }}
                  >
                    <img
                      src={require("../../../assets/rep.png")}
                      alt="2 Days Refundable"
                    />
                  </Box>
                  <Box style={{ textAlign: "left", marginLeft: "10px" }}>
                    <Typography>2 Days Refundable</Typography>
                    {/* <Typography style={{color: "#A9ACB0"}}>Have you ever finally just </Typography> */}
                  </Box>
                </Grid2>
              </Grid2>
            </Grid2>

          </Grid2>

        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default MyCart;
